<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(v-if="" ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localGeoHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
    div.py-2(id="report-geo-visits-info" style="font-size: 14px")
      .p-0 Группы геозон: {{reportData.Data.GeofenceGroups}}
      .p-0 Минимальная длительность: {{reportData.Data.MinCrossingTime}}
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'GeofencesVisitAnalysis',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'GeofenceName',
        caption: 'Название геозоны',
      }, {
        dataField: 'PeriodsText',
        caption: 'Периоды посещения',
        allowSorting: true,
        allowFiltering: false,
        alignment: 'center',
        cellTemplate: (element, info) => {
          element.insertAdjacentHTML('beforeend', info.data.Periods.length === 0 ? 'не посещалось' : info.data.Periods.map(x => `${new Date(x.Begin * 1000).toLocaleString('ru-RU', { timeZone: 'UTC' })} - ${new Date(x.End * 1000).toLocaleString('ru-RU', { timeZone: 'UTC' })}`).join('<br/>'));
        },
      }],
      reportSummary: [],
    };
  },
  computed: {
    localGeoHeight () {
      return `calc(${this.localHeight} - 58px)`;
    },
  },
  watch: {
    reportData (value) {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
  },
  methods: {
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        //
      }
    },

    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },
  },
};
</script>
